exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-box-sm[data-v-c994218e] {\n  background-color: #fff;\n}\n.input-card-label label[data-v-c994218e]:hover,\n.sau-product-card label[data-v-c994218e]:hover,\n.sau-product-card-button label[data-v-c994218e]:hover {\n  border: 2px solid #e5e5e5;\n  box-shadow: none;\n}", ""]);

// exports
